import { Popover } from "@mui/material";
import React, { useState, useContext } from "react";
import InputForm from "../../../Components/InputForm/InputForm";
import { makeStyles } from "@mui/styles";
import notify from "../../../Helpers/ToastNotification";
import { ApplicationStatus } from "../../../Helpers/Enums/ApplicationStatus";
import { APICall } from "../../../Helpers/Network/APICalls";
import { insertIntoMemberEnrollmentHistory } from "../../../Helpers/APIEndPoints/EndPoints";
import { useNavigate } from "react-router-dom";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import Checkbox from "../../../Components/Checkbox/Checkbox";
import "./VerifyModal.css";
import { Modules } from "../../../Helpers/Enums/Modules";
import { RoleEnum } from "../../../Helpers/Enums/RoleEnum";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
const useGapStyles = makeStyles({
  paper: {
    marginTop: "-1rem",
  },
});

const VerifyModal = ({ open, anchorEl, handleClose, memberid, module }) => {
  const [hideShowComment, setHideShowComment] = useState(true);
  const [comment, setComment] = useState("");
  const [approve, setApprove] = useState(false);
  const [reject, setReject] = useState(false);
  const [error, setError] = React.useState<any>({});
  const navigate = useNavigate();
  const context = getContext();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const classes = useGapStyles();

  const onChange = (event, value) => {
    if (event === "comment") {
      setComment(value);
    } else if (event === "approve") {
      setApprove(value);
      setReject(!value);

      setHideShowComment(true);
      setComment("");
    } else if (event === "reject") {
      setReject(value);
      setApprove(!value);

      setHideShowComment(false);
    }
  };

  const onSubmit = async () => {
    let errorObj = {};
    showLoader() 
   
    if (approve == false && reject == false) {
      notify(1, "Select at least one checkbox.");

      errorObj = { approve: "Select at least one checkbox." };
    }

    if (approve == false) {
      if (comment == "") {
        errorObj = {
          ...errorObj,
          [comment]: "This field is required",
        };
      }
    }

    setError(errorObj);

    if (Object.keys(errorObj).length === 0) {
      let statusId = 0;

      let requestParams = {
        MemberId: memberid,
        StatusId: statusId,
        Remarks: comment,
        ModifiedBy: context?.Id,
      };
      if (module === Modules.RegistrationApproval) {
        if (approve === true) {
          statusId =
            ApplicationStatus.MemberRegistrationModule_PendingWithMemberForPaymentDetails;
        }

        if (reject === true) {
          statusId = ApplicationStatus.MemberRegistrationModule_RejectedHRHOD;
        }
        requestParams["EvalInternalTeamUserId"] = context?.Id;
      } else if (module === Modules.PaymentVerification) {
        const isEnrollmentComittee =
          context.loggedInAs?.value === RoleEnum.EnrollmentCommittee;
        if (approve === true) {
          statusId = isEnrollmentComittee
            ? ApplicationStatus.MemberRegistrationModule_MemberRequestApproved
            : ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee;
        }

        if (reject === true) {
          statusId = isEnrollmentComittee
            ? ApplicationStatus.MemberRegistrationModule_MemberRequestRejected
            : ApplicationStatus.MemberRegistrationModule_RejectedByInternalTeam;
        }

        if (isEnrollmentComittee) {
          requestParams["EvalEnrollmentCommitteeUserId"] = context?.Id;
        } else {
          requestParams["EvalAdminUserId"] = context?.Id;
        }
      }
      requestParams.StatusId = statusId;

      const res = await APICall(
        insertIntoMemberEnrollmentHistory,
        requestParams
      );

      if (res.Message === "Sucess") {
        let mesaage = "";

        if (approve === true) {
          mesaage = "Approve";
        }

        if (reject === true) {
          mesaage = "Reject";
        }

        notify(0, `Request ${mesaage} Successfully`);
        handleClose();
        navigate("/MemberVerification");
      }
    }
    hideLoader()
  };

  return (
    <Popover
      id={"id"}
      open={open}
      anchorEl={anchorEl}
      onClose={() => handleClose()}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      classes={{
        paper: classes.paper,
      }}
      className=""
    >
      <div className="p-3 verify-modal">
        <div className="col-lg-12 col-md-12">
          <div className="row">
            <div className="col-lg-4 col-sm-4 col-xs-4">
              {/* <div className="">
                <input
autoComplete={AutoCompleteValue}
                  placeholder={""}
                  value={""}
                  onChange={(val: any) => {
                    let value = val.target.checked;
                    onChange("approve", value);
                  }}
                  type="radio"
                  name="varificarion"
                />{" "}
                <span style={{ marginLeft: "12px" }}>Approve</span>
              </div> */}
              <Checkbox
                id="approve"
                title="Approve"
                onChange={onChange}
                checked={approve}
              />
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              {/* <div className="">
                <input
autoComplete={AutoCompleteValue}
                  placeholder={""}
                  value={""}
                  onChange={(val: any) => {
                    let value = val.target.checked;
                    onChange("reject", value);
                  }}
                  type="radio"
                  name="varificarion"
                />{" "}
                <span style={{ marginLeft: "12px" }}>Reject</span>
              </div> */}
              <Checkbox
                id="reject"
                title="Reject"
                onChange={onChange}
                checked={reject}
              />
            </div>
          </div>
          <br />
          {!hideShowComment && (
            <div className="row pb-3">
              <div className="col-lg-12 col-sm-12 col-xs-12 ">
                <div className="form-group">
                  <label>Comments</label>
                  <sup>*</sup>
                  <InputForm
                    placeholder={""}
                    value={comment}
                    textArea={true}
                    rows={4}
                    onChange={(val: any) => {
                      let value = val.target.value;
                      onChange("comment", value);
                    }}
                  />
                </div>
                {error[comment] && (
                  <p style={{ color: "red" }}>{error[comment]}</p>
                )}
              </div>
            </div>
          )}
        </div>
        <div className="d-flex justify-content-end">
          <ButtonComponent
            icon={""}
            className="btn btn-cancel"
            style={{ marginLeft: 5 }}
            onClick={handleClose}
            value={"Cancel"}
            id={"cancelBtn"}
          />
          <ButtonComponent
            icon={""}
            value={"Submit"}
            style={{ marginLeft: "10px" }}
            id={"saveBtn"}
            onClick={() => onSubmit()}
          />
        </div>
      </div>
    </Popover>
  );
};

export default VerifyModal;
